import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { TaskServiceInterface } from './definitions/task-service-interface';
import { Observable } from 'rxjs';
import { ErrorsInterface } from '../errors/errors-interface';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface ToCalculationResponse {
  task: {
    toCalculation: {
      output: TaskServiceInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class TaskToCalculationService {
  constructor(private apollo: Apollo) {}

  toCalculation(
    taskId,
    mutation: DocumentNode
  ): Observable<FetchResult<ToCalculationResponse>> {
    return this.apollo.mutate<ToCalculationResponse>({
      mutation: mutation,
      variables: {
        taskId,
      },
    });
  }
}
